import { useState } from "react";
import "./ProfileStats.css";

function ProfileStats({ progress }) {
    // Get sport names from sportScores
    const sports = progress?.sportScores 
        ? progress.sportScores.map(sportScore => sportScore.sport.name)
        : [];

    const [activeSport, setActiveSport] = useState("All");

    // Function to get sport-specific or overall stats
    const getStats = () => {
        if (!progress)  return {
            "Coins": 0,
            "Matches played": 0 ,
            "Matches won": 0,
            "Matches lost": 0,
            // "Avg. Score per Match": 0.00,
            "Win/loss %": 0
        };

        // Overall stats if "All" is selected
        if (activeSport === "All") {
            return {
                "Coins": progress.overallScore,
                "Matches played": progress.totalMatches ,
                "Matches won": progress.matchesWon,
                "Matches lost": progress.totalMatches - progress.matchesWon,
                // "Avg. Score per Match": (progress.overallScore / (progress.totalMatches || 1)).toFixed(2),
                "Win/loss %": Math.ceil(progress.matchesWon * 100 / (progress.totalMatches || 1))
            };
        }

        // Sport-specific stats
        const sportStats = progress.sportScores.find(ss => ss.sport.name === activeSport);
        if (!sportStats) return {};

        return {
            "Matches played": sportStats.totalMatches,
            "Matches won": sportStats.wonMatches,
            "Matches lost": sportStats.totalMatches - sportStats.wonMatches,
            // "Coins": sportStats.score,
            // "Avg. Score per Match": (sportStats.score / (sportStats.totalMatches || 1)).toFixed(2),
            "Win/loss %": Math.ceil(sportStats.wonMatches*100 / (sportStats.totalMatches || 1))
        };
    };

    const fetchedStat = getStats();

    const EmojiStat = {
        "Matches played": "🥎",
        "Matches won": "🏆",
        "Matches lost": "🙆‍♂️",
        "Coins": "📊",
        // "Avg. Score per Match": "🤾‍♂️",
        "Win/loss %": "🎯"
    };

    // Include "All" in sports tabs
    const allSports = ["All", ...sports];

    return (
        <div className="statContainer">
            <div className="sportsNav">
                {allSports.map((sport) => (
                    <p
                        key={sport}
                        className={`sportTab ${activeSport === sport ? "sportTab_active" : ""}`}
                        onClick={() => setActiveSport(sport)}
                    >
                        {sport}
                    </p>
                ))}
            </div>
            <div className="statMatrix">
                {Object.keys(fetchedStat).map((statKey) => (
                    <div key={statKey} className="statBox">
                        <p className="statLabel">{statKey}</p>
                        <p className="StatInfo">
                            {statKey === "Coins" ? (
                                <>
                                    <img src="/images/token.gif" height={30} width={30} alt="token" className="relative -top-1" />
                                    <span className="StatNum">{fetchedStat[statKey]}</span>
                                </>
                            ) : (
                                <>
                                    {EmojiStat[statKey]} <span className="StatNum">{fetchedStat[statKey]}{statKey === 'Win/loss %' ? '%' :''}</span>
                                </>
                            )}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default ProfileStats;